export const EMAIL_VERIFICATION_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
